// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"LoadingCard_iconWrapper__qagex","pulse-anim":"LoadingCard_pulse-anim__cW2eH"};